/*
	uview 组件 表单校验
*/

export const validateForm = (form,rules)=>{
	for (const key in rules) {
		if (Object.hasOwnProperty.call(rules, key) && Object.hasOwnProperty.call(form, key)) {
			const element = rules[key];
			
		}
	}
}
/**
 * 
 * @param {String} formValue 表单的值
 * @param {*} ruleList 
 */
/**
 * rule 方法对象
 * {
 * 		regexpFun
 * 		message
 * 		
 * }
 */
export const validateFormValue = (formValue,ruleList)=>{
	for (let index = 0; index < ruleList.length; index++) {
		const element = ruleList[index];
		
	}
}


// 检验特殊字符
export const validateSymbols = (rule, value, callback) => {
	var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%+_\-]");
	if (!value) {
		return true
	}

	if (pattern.test(value)) {
		return false
	} else {

		return true
	}
}

// 检验手机号
export const validatePhone = (rule, value, callback) => {
	if (!value) {
		return false
	}
	let reg = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;

	if (!reg.test(value)) {
		return false
	} else {
		return true
	}
}

/*
	uview 组件 表单组件 输入内容过滤
*/

// 输入框输入空格过滤
export const filterSpace = (v) => {
	return v.replace(/\s*/g, '')
}

// 输入框 特殊字符过滤
export const filterSymbol = (v) =>{
	var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%+_\-]",'g');
	return v.replace(pattern, '')
}

// 校验汉字
export const validateChinese = (rule, value, callback) =>{
	let reg = /[\u4e00-\u9fa5]/g
	if (!reg.test(value)) {
		return true
	} else {
		return false
	}
}


// 20220905 
// 校验密码
export const validatePWD = (rule, value, callback) => {
	const pattern1 = /^(?:(?=.*[0-9].*)(?=.*[A-Za-z].*))[,\.#%'\+\*\-:;^_`0-9A-Za-z]{6,20}$/
	const pattern2 = /^(?:(?=.*[0-9].*)(?=.*[,\.#%'\+\*\-:;^_`].*))[,\.#%'\+\*\-:;^_`0-9A-Za-z]{6,20}$/
	if (!pattern1.test(value) && !pattern2.test(value)) {
		return true
	}
	return false
}

